import store from '@/store'
import {
  Json2UrlQuery
} from '@/common/util.js'

function hideMenu() {
  if (window.location.href.match(/center=[^&]*/) != null) {
    var centerString = window.location.href.match(/center=[^&]*/)[0];
    var center = centerString.replace('center=', '');
    if (center == 'true') {
      store.commit('hideLeftAside')
    }
  } else {
    store.commit('showLeftAside')
  }
}

function jump(options) {
  if (!options.url) {
    return false
  }
  let param = options.query ? '&' + Json2UrlQuery(options.query) : ''
  let jumpWindow = window.open(window.location.origin + '/' + options.url + '?' + param + '&center=true')
  return jumpWindow
}
export {
  jump,
  hideMenu
}



// WEBPACK FOOTER //
// ./src/common/jump.js